import SettingsCard from '../settings_card'
import CategoryField from './categories/category_field'
import { mapAssignedCategory } from './categories/category_helpers'

const PREROLL_CONTENT_TYPES = ['movie', 'episode', 'series']

const PrerollCard = ({ asset, cycleID, langID }) => {
  const assetType = asset?.asset_type
  const showContentPrerolls = PREROLL_CONTENT_TYPES.includes(assetType)
  const showPrerollAdPools = assetType === 'ad' && asset?.is_preroll_ad

  if (!showContentPrerolls && !showPrerollAdPools) return null

  const categories = asset.categories ?? []
  const warningSlateCategories = categories.filter((cat) => cat.type === 'warning-slates')
  const prerollCategories = categories.filter((cat) => cat.type === 'ad-pools')
  const availableWarningSlates = asset.available_warning_slates ?? []
  const availablePreroll = asset.available_preroll ?? []

  return (
    <SettingsCard title='Pre-roll' description='Warning slate groups and ad pools for this asset.'>
      {showContentPrerolls ? (
        <>
          <CategoryField
            title='Warning Slate Group'
            options={availableWarningSlates}
            value={warningSlateCategories.map((category) => mapAssignedCategory(category, categories, langID))}
            key='warning-slates'
            assetID={asset.id}
            cycleID={cycleID}
            langID={langID}
            type='warning-slates'
          />
          <CategoryField
            title='Ad Pools'
            options={availablePreroll}
            value={prerollCategories.map((category) => mapAssignedCategory(category, categories, langID))}
            key='prerolls'
            assetID={asset.id}
            cycleID={cycleID}
            langID={langID}
            type='ad-pools'
          />
        </>
      ) : (
        <CategoryField
          title='Ad Pools'
          options={availablePreroll}
          value={prerollCategories.map((category) => mapAssignedCategory(category, categories, langID))}
          key='ad-pools'
          assetID={asset.id}
          cycleID={cycleID}
          langID={langID}
          type='ad-pools'
          isMulti={true}
        />
      )}
    </SettingsCard>
  )
}

export default PrerollCard
